export default {
  PUSH_FORM: 'PUSH_FORM',
  PUSH_FORMS: 'PUSH_FORMS',
  REPLACE_FORM: 'REPLACE_FORM',
  REPLACE_FORMS: 'REPLACE_FORMS',
  RESET_FORMS_STATE: 'RESET_FORMS_STATE',
  SET_FORMS_IS_LOADING: 'SET_FORMS_IS_LOADING',
  SET_IS_EDITING_FORM: 'SET_IS_EDITING_FORM',
  SET_SELECTED_FORM: 'SET_SELECTED_FORM',
  CREATE_FORM: 'CREATE_FORM'
};
